<tr *ngFor="let tender of tenders" (click)="viewTender(tender)" class="pointer">
  <td class="align-middle" data-label="">
    <div class="td d-flex align-items-center text-capitalize fw-bold text-dark">{{ tender.name ? tender.name :
      "Draft Tender" }}</div>
  </td>
  <td class="align-middle text-center" data-label="Locations">
    {{ tender.stats.contractsTotal }}
  </td>
  <td class="align-middle text-center" data-label="Suppliers">
    {{ tender.stats.suppliersTotal }}
  </td>
  <td class="align-middle text-center" data-label="Bids">
    <span *ngIf="tender.status === 'DRAFT'" class="text-muted">-</span>
    <span *ngIf="tender.status !== 'DRAFT'">{{ tender.stats.bidsSubmittedTotal }}</span>
  </td>
  <td class="align-middle text-center" data-label="Round">
    <span *ngIf="tender.status === 'DRAFT'" class="text-muted">-</span>
    <span *ngIf="tender.status !== 'DRAFT'">Round {{ tender.currentRound }}</span>
  </td>
  <td class="align-middle text-center" data-label="Round Time">
    <span *ngIf="tender.status === 'DRAFT'" class="text-muted">-</span>
    <ng-container *ngIf="tender.status !== 'DRAFT'">
      <jft-time-remaining *ngIf="tender.dateRoundEnd"
        [round]="{round: tender.currentRound, dateEnd: tender.dateRoundEnd, isClosed: !tender.isActive()}"
        [showRoundName]="false" [showSeconds]="false"></jft-time-remaining>
      <span *ngIf="!tender.dateRoundEnd" class="text-muted small">N/A</span>
    </ng-container>
  </td>
  <td class="align-middle text-center" data-label="Round Status">
    <jft-round-status *ngIf="tender.status !== 'DRAFT' && tender.currentRoundStatus"
      [status]="tender.currentRoundStatus"></jft-round-status>
    <span *ngIf="tender.status === 'DRAFT'" class="text-muted">-</span>
  </td>
  <td class="align-middle text-center" data-label="Tender Status">
    <jft-tender-status [status]="tender.status"></jft-tender-status>
  </td>
</tr>

<tr *ngIf="!tenders.length" class="no-tenders-row">
  <td colspan="8">
    <p class="text-center small mt-5">No tenders to display</p>
    <p class="text-center small mb-5">
      <button *ngIf="!company.isChild" class="btn btn-outline-primary">
        <create-tender-button></create-tender-button>
      </button>
    </p>
  </td>
</tr>
